export default {
  fr: {
    email: "Courriel",
    forgot_password: "J'ai oublié mon mot de passe",
    google: "Se connecter avec Google",
    login: "Connexion",
    login_submit: "Se connecter",
    or: "OU",
    password: "Mot de passe",
    remember_me: "Se souvenir de moi",
    show_password: "Afficher le mot de passe",
    hide_password: "Masquer le mot de passe",
    password_shown: "Votre mot de passe est affiché !",
    password_hidden: "Votre mot de passe est masqué",
  },
  en: {
    email: "Email",
    forgot_password: "Forgot password?",
    google: "Sign in with Google",
    login: "Login",
    login_submit: "Login",
    or: "OR",
    password: "Password",
    remember_me: "Remember me",
    show_password: "Show password",
    hide_password: "Hide password",
    password_shown: "Your password is shown!",
    password_hidden: "Your password is hidden",
  },
};
